import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "list", "empty", "group", "option"]

  filter() {
    const query = this.searchTarget.value.trim().toLowerCase()
    let visibleCount = 0

    this.groupTargets.forEach((group) => {
      let groupVisible = 0

      group.querySelectorAll("[data-specialization-filter-target='option']").forEach((option) => {
        const keywords = (option.dataset.keywords ?? option.textContent).trim().toLowerCase()
        const match = !query || keywords.includes(query)
        option.classList.toggle("hidden", !match)
        if (match) groupVisible++
      })

      group.classList.toggle("hidden", groupVisible === 0)
      visibleCount += groupVisible
    })

    if (this.hasEmptyTarget) {
      const showEmpty = query.length > 0 && visibleCount === 0
      this.emptyTarget.classList.toggle("hidden", !showEmpty)
    }
  }
}
